import { createAction, props } from '@ngrx/store';

import { CollectionCommands } from '../../../domain/commands/collection.commands';
import { CollectionGroup, TemplateGroup } from '../../../domain/models/collection.models';

export const GetCollectionApi = createAction(
    CollectionCommands.GET_COLLECTION_API,
    props<{ slug: string; vip?: boolean }>()
);

export const GetCollectionApiSuccess = createAction(
    CollectionCommands.GET_COLLECTION_API_SUCCESS,
    props<{ slug: string; collectionGroup: CollectionGroup[] }>()
);

export const GetCollectionCachedSuccess = createAction(CollectionCommands.GET_COLLECTION_CACHED_SUCCESS);

export const GetCollectionApiError = createAction(
    CollectionCommands.GET_COLLECTION_API_ERROR,
    props<{ error: string }>()
);

export const SetUniqueCachedSlugs = createAction(
    CollectionCommands.SET_COLLECTION_SLUG_CACHED,
    props<{ uniqueCachedSlugList: string[] }>()
);

export const SetCollectionGroup = createAction(
    CollectionCommands.SET_COLLECTION_GROUP,
    props<{ slug: string; templateGroup: TemplateGroup[] | CollectionGroup[] }>() // TemplateGroup[] Es Temporal pertenece logica de negocio ECOMDUTI-29270
);

export const HandleCollectionOfCollections = createAction(
    CollectionCommands.HANDLE_COLLECTION_OF_COLLECTIONS,
    props<{ slug: string; collectionGroup: CollectionGroup[] }>()
);
